module.exports = __webpack_public_path__ + "static/media/3_l_ventilytor_11.15_60.46.b3768419.png";